import { createFileRoute } from "@tanstack/react-router";
import { CredentialEditPage } from "@client/components/tool-workshop/credential-edit-page";

function RouteComponent() {
  const { credentialId } = Route.useParams();
  return <CredentialEditPage key={credentialId} />;
}

export const Route = createFileRoute("/_app/bots/credentials/$credentialId")({
  component: RouteComponent,
});
